import { Person } from '@mui/icons-material';
import { useGridApiRef } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';

import { SolaForceDataGrid } from '~/components/SolaForceDataGrid';
import {
  AnalyticsReportDefaultProps,
  AnalyticsReportEmployeeScope,
  AnalyticsReportTypes,
  useFormerAndNewEmployeesReportData,
} from '~/data/reports';
import {
  ReportColumnsVisibility,
  ReportDataExport,
  ReportDatasetLayout,
  ReportDatasetRowCount,
  ReportViewLayout,
  useReportDataset,
} from '~/scenes/PortalModules/Analytics/common';
import { useFormerAndNewEmployeesReport } from '~/scenes/PortalModules/Analytics/People/FormerEmployeesReport/useFormerAndNewEmployeesReport';

export const NewEmployeesReport = () => {
  const { t } = useTranslation();

  const apiRef = useGridApiRef();

  const defaultReportSettings: AnalyticsReportDefaultProps<object> = {
    reportType: {
      type: AnalyticsReportTypes.Company,
    },
    params: {
      empScope: AnalyticsReportEmployeeScope.NewEmployees,
    },
  };

  const { reportSelection } = useReportDataset({
    selection: defaultReportSettings,
  });

  const { data, isLoading } =
    useFormerAndNewEmployeesReportData(reportSelection);

  const { columns, rows } = useFormerAndNewEmployeesReport({ data });

  return (
    <ReportViewLayout
      heading={t('laNewEmpList')}
      slots={{
        toolbar: {
          main: (
            <ReportDatasetLayout>
              <ReportDatasetRowCount
                count={rows.length}
                description={t('laTotalRecords')}
                icon={<Person />}
              />
            </ReportDatasetLayout>
          ),
          actions: (
            <>
              <ReportColumnsVisibility apiRef={apiRef} isLoading={isLoading} />
              <ReportDataExport
                title={t('laNewEmpList')}
                apiRef={apiRef}
                isLoading={isLoading}
              />
            </>
          ),
        },
      }}
    >
      <SolaForceDataGrid
        apiRef={apiRef}
        columns={columns}
        rows={rows}
        loading={isLoading}
        density={'compact'}
        getRowId={(row) => row.employeeId}
        pinnedColumns={{
          left: ['employeeId', 'firstName', 'lastName'],
        }}
      />
    </ReportViewLayout>
  );
};
